import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import Box from '@material-ui/core/Box';
import Button from '../../generic/Button.js';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as MuteAll } from '../../../assets/mute_all.svg';

const useStyles = makeStyles((theme) => ({
  container: {
    background:
      theme.palette.type === 'light'
        ? theme.palette.grey[300]
        : theme.palette.primary.dark,
  },
}));

const ParticipantActions = ({
  quickJoin = true,
  isLocked = false,
  hideGuestLogin = false,
  onEvent,
}) => {
  const classes = useStyles();
  return (
    <Box
      p={2}
      display="flex"
      flexDirection="row"
      flexWrap="nowrap"
      className={classes.container}
    >
      {quickJoin && !isLocked && !hideGuestLogin && (
        <Button
          onClick={() => onEvent({ type: 'guest_link' })}
          icon="person_add"
        >
          {I18n.t('participants:quick_join')}
        </Button>
      )}
      <Button
        icon={<MuteAll />}
        type="secondary"
        onClick={() => onEvent({ type: 'show_muteall_dialog' })}
      >
        {I18n.t('participants:mute_all')}
      </Button>
    </Box>
  );
};

ParticipantActions.propTypes = {
  onEvent: PropTypes.func.isRequired,
  quickJoin: PropTypes.bool,
};

export default ParticipantActions;
